import { Typography } from '@breetometer/components';
import type { ReactNode } from 'react';

const TransactionDetailsRowRight = ({ children, value }: { children?: ReactNode; value?: ReactNode }) => (
	<div className='transaction-details_content_row_right'>
		{value ? <Typography className='transaction-details_content_row_value color-neutral-50'>{value}</Typography> : children}
	</div>
);

export default TransactionDetailsRowRight;
